query allMarketDisplayConfigurations(
  $filter: MarketDisplayConfigurationFilter,
  ) {
  allMarketDisplayConfigurations(
    orderBy: POSITION_ASC,
    filter: $filter
  ) {
    nodes {
      defaultName,
      groupView
      active
      marketCode
      parameters
      position
      selections
      shortNamePattern
      longNamePattern
      grouped
      sportId
      operatorId
      createdAt
      createdBy
    }
  }
}
